import React from "react";
import { Row, Col } from "reactstrap";

import IconList from "components/HyperDrive/IconList";

import train from "assets/img/hyperdrive/train.gif";

const WhyMagLev = ({isMobile}) => {
  return (
    <>
      <h2 className="text-center" style={{ color: "white", marginBottom: '20px' }}>Why MagLev?</h2>
      <p className="text-center" style={{ color: "white", fontSize: '1.25em', marginBottom: '10px', paddingLeft:isMobile ? '0em':'3.5em', paddingRight:isMobile ? '0em':'3.5em'}}>
      A large diameter hollow rotor exhibits higher surface speeds and centrifugal loading, which limits conventional rolling support to prohibitively low rotor speeds and service life.
      Maglev trains are suspended and propelled by contactless magnetic fields enabling overall higher speed operation and the following benefits:
      </p>
      <IconList/>
      <Row style={{ marginBottom: '20px' }}>
        <Col xs={12} lg={12} md={12} className="text-center d-flex align-items-center mb-4 mb-md-0 order-2">
          <div style={{ width: '100%', textAlign: 'center' }}>
            <img src={train} style={{width:'55%'}} alt="loading..." />
            <p className="text-lg-center" style={{ color: "white", fontSize: '1.25em', marginTop: '20px', paddingLeft: isMobile ? '0em':'3.5em', paddingRight: isMobile ? '0em':'3.5em'}}>
              We leverage the advantages of frictionless maglev trains in the air. At the core of the MagLev HyperDrive&trade; is a fault tolerant and resilient maglev motor-bearing system supporting the slowed rim driven rotor.
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default WhyMagLev;
